export enum ECreativeCtvFormat {
  Standard = 'Standard',
  BigShow = 'BigShow',
}

export enum ECtvVideoUploadType {
  Video = 'Video',
  VastTag = 'VastTag',
}
